var React = require('react');

function Tag (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("path",{"d":"M0,0h24v24H0V0z","fill":"none"})),React.createElement("g",{"key":1},React.createElement("g",null,[React.createElement("path",{"d":"M21.41,11.41l-8.83-8.83C12.21,2.21,11.7,2,11.17,2H4C2.9,2,2,2.9,2,4v7.17c0,0.53,0.21,1.04,0.59,1.41l8.83,8.83 c0.78,0.78,2.05,0.78,2.83,0l7.17-7.17C22.2,13.46,22.2,12.2,21.41,11.41z M12.83,20L4,11.17V4h7.17L20,12.83L12.83,20z","key":0}),React.createElement("circle",{"cx":"6.5","cy":"6.5","r":"1.5","key":1})]))]);
}

Tag.defaultProps = {"enableBackground":"new 0 0 24 24","height":"24px","viewBox":"0 0 24 24","width":"24px","fill":"#000000"};

module.exports = Tag;

Tag.default = Tag;
